import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Col,
  Row,
  ModalFooter,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Label } from "reactstrap";
import { withNamespaces } from "react-i18next";
import showNotification from "../../../helpers/show_notification";
import { convertToLowestUnit } from "../../../helpers/units";
import { formatUnitsForReport } from "../../../helpers/units";
import { GetUpdatedDelivered } from "../../../helpers/units";
import preventValueChangeOnScroll from "../../../helpers/PreventValueOnScroll";

const UpdateQuantityWithRemark = ({
  isOpen,
  toggle,
  onSubmit,
  item,
  t, 
}) => {

  console.log(item,"item");
  
  const [rollbackQuantity, setRollbackQuantity] = useState(0);
  const [damagedQuantity, setDamagedQuantity] = useState(0);
  const [remarks, setRemarks] = useState("");
  const [remainingQuantityInLowestUnit, setRemainingQuantityInLowestUnit] =
    useState(0);

  useEffect(() => {
        console.log("mount");
    if (item && item.unit_levels) {
      let rollback_quantity =
        convertToLowestUnit(item.unit_levels, item.rollback_quantity) || 0;
      let damaged_quantity =
        convertToLowestUnit(item.unit_levels, item.damaged_quantity) || 0;
      let current_remaining_quantity =
        convertToLowestUnit(
          item.unit_levels,
          item.current_remaining_quantity
        ) || 0;
      // setRollbackQuantity(0);
      // setDamagedQuantity(0);
      if (current_remaining_quantity > 0) {
        setRemainingQuantityInLowestUnit(current_remaining_quantity);
      } else {
        setRemainingQuantityInLowestUnit(
          Number(rollback_quantity) + Number(damaged_quantity)
        );
      }
      setRemarks(item?.csm_remarks || "");
      setRollbackQuantity(+rollback_quantity);
      setDamagedQuantity(+damaged_quantity);
    }

  }, [item,toggle]);

  const handleSubmit = () => {
    if (!item?.unit_levels || item.unit_levels.length === 0) {
      showNotification("Unit levels not found for the item.", "Warning");
      return false;
    }

    if (remainingAfter !== 0) {
      showNotification(
        "Remaining quantity must be 0 before applying changes.",
        "Warning"
      );
      return false;
    }

    const lastUnit = item.unit_levels[item.unit_levels.length - 1]?.unit;

    const formattedRollbackQuantity = GetUpdatedDelivered(
      [{ unit: lastUnit, value: rollbackQuantity }],
      item.unit_levels
    );

    const formattedDamagedQuantity = GetUpdatedDelivered(
      [{ unit: lastUnit, value: damagedQuantity }],
      item.unit_levels
    );

    if (
      onSubmit(formattedRollbackQuantity, formattedDamagedQuantity, remarks)
    ) {
      handleToggle();
      setRollbackQuantity(0);
      setDamagedQuantity(0);
      setRemarks("");
    }
  };

  const handleRollbackQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    setRollbackQuantity(isNaN(value) ? 0 : value);
  };

  const handleDamagedQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    setDamagedQuantity(isNaN(value) ? 0 : value);
  };

  const totalAllocated = rollbackQuantity + damagedQuantity;
  const remainingAfter = remainingQuantityInLowestUnit - totalAllocated;
// console.log(remainingQuantityInLowestUnit,"remainingQuantityInLowestUnit");
// console.log(rollbackQuantity,"rollbackQuantity");
// console.log(damagedQuantity,"damagedQuantity"); 
// console.log(totalAllocated,"totalAllocated"); 
// console.log(remainingAfter,"remainingAfter");

  const formatQuantity = (quantityInLowestUnit) => {
    if (!item?.unit_levels || item.unit_levels.length === 0) {
      return quantityInLowestUnit + " ROLL";
    }
    const formatted = GetUpdatedDelivered(
      [
        {
          unit: item.unit_levels[item.unit_levels.length - 1]?.unit,
          value: quantityInLowestUnit,
        },
      ],
      item.unit_levels
    );
    return formatUnitsForReport(formatted, item.unit_levels);
  };

  function mapUnits(unitLevels) {
    if (!unitLevels || unitLevels.length === 0) {
      return "";
    }

    if (unitLevels.length > 1) {
      return unitLevels
        .slice(1)
        .map((unit, ind) => {
          const prevUnit = unitLevels[ind]?.unit;
          return `1 ${prevUnit} = ${unit.value} ${unit.unit}`;
        })
        .join(", ");
    } else {
      return unitLevels[0].unit;
    }
  }

  function handleToggle (){
    toggle()
      setRemainingQuantityInLowestUnit(0);
      setDamagedQuantity(0);
      setRollbackQuantity(0);
      setRemarks('')
  }

  return (
    <Modal isOpen={isOpen} toggle={handleToggle} size="md">
      <AvForm onValidSubmit={handleSubmit}>
        <ModalHeader toggle={handleToggle}>Manage Remaining Quantity</ModalHeader>
        <ModalBody>
          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex ">
                <span style={{ fontWeight: 600, minWidth: "100px" }}>Item</span>
                <span style={{ minWidth: "200px" }}>: {item?.name}</span>
              </div>

              <div className="d-flex ">
                <span style={{ fontWeight: 600, minWidth: "100px" }}>
                  Formula
                </span>
                <span style={{ minWidth: "200px" }}>
                  : {mapUnits(item?.unit_levels)}
                </span>
              </div>

              <div className="d-flex">
                <span style={{ fontWeight: 600, minWidth: "100px" }}>
                  Remaining
                </span>
                <span style={{ minWidth: "200px" }}>
                  :{" "}
                  {item?.current_remaining_quantity
                    ? formatUnitsForReport(
                        item.current_remaining_quantity,
                        item.unit_levels
                      )
                    : `0 ${
                        item?.unit_levels?.[item.unit_levels.length - 1]
                          ?.unit || ""
                      }`}
                </span>
              </div>
            </div>

            <Row className="mb-3">
              <Col sm={6}>
                <Label for="rollback_quantity_input" className="fw-semibold">
                  <i className="fas fa-undo text-danger mr-2"></i>
                  Rollback Quantity
                </Label>

                <Row>
                  <Col lg={8} md={8} xs={10} sm={10}>
                    <AvField
                      name="rollback_quantity_input"
                      type="number"
                      value={`${rollbackQuantity}`}
                      onChange={handleRollbackQuantityChange}
                      min={0}
                      onWheel={preventValueChangeOnScroll}
                      max={remainingQuantityInLowestUnit}
                      validate={{
                        required: {
                          value:
                            rollbackQuantity === 0 && damagedQuantity === 0,
                          errorMessage: t(
                            "Either Rollback or Damaged quantity is required."
                          ),
                        },
                        min: {
                          value: 0,
                          errorMessage: t("Cannot be less than 0"),
                        },
                        max: {
                          value: remainingQuantityInLowestUnit,
                          errorMessage: t("Cannot exceed remaining quantity."),
                        },
                      }}
                      className="form-control"
                      style={{ height: "25px" }}
                    />
                  </Col>
                  <Col lg={4} md={4} xs={2} sm={2}>
                    <span style={{ height: "25px", marginLeft: "-10px" }}>
                      {item?.unit_levels?.[item.unit_levels.length - 1]?.unit ||
                        ""}
                    </span>
                  </Col>
                </Row>
              </Col>

              <Col sm={6}>
                <Label for="damaged_quantity_input" className="fw-semibold">
                  <i className="fas fa-exclamation-triangle text-danger mr-2"></i>
                  Damaged Quantity
                </Label>

                <Row>
                  <Col lg={8} md={8} xs={10} sm={10}>
                    <AvField
                      name="damaged_quantity_input"
                      type="number"
                      value={`${damagedQuantity}`}
                      onChange={handleDamagedQuantityChange}
                      onWheel={preventValueChangeOnScroll}
                      min={0}
                      max={remainingQuantityInLowestUnit - rollbackQuantity}
                      validate={{
                        required: {
                          value:
                            rollbackQuantity === 0 && damagedQuantity === 0,
                          errorMessage: t(
                            "Either Rollback or Damaged quantity is required."
                          ),
                        },
                        min: {
                          value: 0,
                          errorMessage: t("Cannot be less than 0"),
                        },
                        max: {
                          value:
                            remainingQuantityInLowestUnit - rollbackQuantity,
                          errorMessage: t("Cannot exceed remaining quantity."),
                        },
                      }}
                      className="form-control mr-2"
                      style={{ height: "25px" }}
                    />
                  </Col>
                  <Col lg={4} md={4} xs={2} sm={2}>
                    <span style={{ height: "25px", marginLeft: "-10px" }}>
                      {item?.unit_levels?.[item.unit_levels.length - 1]?.unit ||
                        ""}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="border rounded p-2 bg-light">
              <div className="d-flex justify-content-between mb-1">
                <span>Rollback:</span>
                <span>{formatQuantity(rollbackQuantity)}</span>
              </div>
              <div className="d-flex justify-content-between mb-1">
                <span>Damaged:</span>
                <span>{formatQuantity(damagedQuantity)}</span>
              </div>

              <hr className="my-2" />

              <div className="d-flex justify-content-between mb-1">
                <span>Total Allocated:</span>
                <span>{formatQuantity(totalAllocated)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>Remaining After:</span>
                {/* <span style={{ color: remainingAfter > 0 ? 'red' : 'green' }}>{formatQuantity(remainingAfter)}</span> */}
                <span style={{ color: remainingAfter > 0 ? "red" : "green" }}>
                  {remainingAfter}{" "}
                  {item?.unit_levels?.[item.unit_levels.length - 1]?.unit || ""}
                </span>
              </div>
            </div>
          </Col>

          <Row className="mt-3">
            <Col lg={12}>
              <AvField
                name="remarks"
                label={t("Remarks")}
                type="textarea"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                validate={{
                  required: {
                    value: rollbackQuantity > 0 || damagedQuantity > 0,
                    errorMessage: t(
                      "Remarks are mandatory if quantity is changed."
                    ),
                  },
                }}
              />
            </Col>
          </Row>

          {/* <Row className="mt-3">
            <Col lg={12}>
              <div className="text-center">
                <Button type="submit" color="primary">
                  {t("Apply Changes")}
                </Button>
              </div>
            </Col>
          </Row> */}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleToggle}>
            {t("Cancel")}
          </Button>
          <Button type="submit" color="primary">
            {t("Apply Changes")}
          </Button>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

export default withNamespaces()(UpdateQuantityWithRemark);
